/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var getTranslatedString = function getTranslatedString(t) {
  return {
    'carbon.table.row.expand': t('Expand row'),
    'carbon.table.row.collapse': t('Collapse row'),
    'carbon.table.all.select': t('Select all rows on page'),
    'carbon.table.all.unselect': t('Unselect all rows'),
    'carbon.table.row.select': t('Select row'),
    'carbon.table.row.unselect': t('Unselect row'),
    'carbon.table.batch.cancel': t('Cancel'),
    'carbon.table.toolbar.search.label': t('Search'),
    'carbon.table.toolbar.search.placeholder': t('Search'),
    'carbon.table.all.expand': t('Expand all rows'),
    'carbon.table.all.collapse': t('Collapse all rows'),
    'open.menu': t('Open menu'),
    'close.menu': t('Close menu'),
    'clear.all': t('Clear all'),
    'clear.selection': t('Clear selected')
  };
};
var translateWithId = function translateWithId(id, t, interpolation, options) {
  // Set override per each carbon translation id if desired
  if (id === 'carbon.table.header.icon.description') {
    if (options.isSortHeader) {
      if (options.sortDirection === options.sortStates.NONE) {
        return t('Sort ascending');
      }
      if (options.sortDirection === options.sortStates.ASC) {
        return t('Sort descending');
      }
      return t('Remove sort');
    }
    return t('Sort ascending');
  }
  return getTranslatedString(t)[id] || '--';
};
var _translateWithId = translateWithId;

export { _translateWithId as default };
